import React, { useRef } from "react"
import { ThemeProvider } from "styled-components"

import componentThemeExtension from "utils/componentThemeExtension"

import { StyledTable } from "./styles"

const Table = ({ element }) => {
  const ref = useRef(null)

  // default missing values to true
  element.dataHasHeaderRow = typeof element.dataHasHeaderRow === "undefined" ? true : element.dataHasHeaderRow
  element.lockFirstColumnOnMobile = typeof element.lockFirstColumnOnMobile === "undefined" ? true : element.lockFirstColumnOnMobile

  const nColumns = [...element.tableData.matchAll(/<th>/g)].length

  return (
    <ThemeProvider theme={componentThemeExtension("White")}>
      <StyledTable
        dataId={element.id}
        elRef={ref}
        tableData={element.tableData}
        displayTrueFalseAsCheckmarks={element.displayTrueFalseAsCheckmarks}
        dataHasHeaderRow={element.dataHasHeaderRow}
        headerRowColor="White"
        evenRowColor="White"
        oddRowColor="White"
        headerAlign={element.headerAlign}
        cellAlign={element.cellAlign}
        firstColumnAlign={element.firstColumnAlign}
        lastColumnAlign={element.lastColumnAlign}
        fullWidth={element.fullWidth}
        lockFirstColumnOnMobile={element.lockFirstColumnOnMobile}
        stretch={nColumns >= 5}
      />
    </ThemeProvider>
  )
}

export default Table
